// extracted by mini-css-extract-plugin
module.exports = {"errorInfo":"StrategyPage_errorInfo__1FCU4"};